import React, { PureComponent } from "react";
import Table from "antd/lib/table";
import Input from "antd/lib/input";
import Button from "antd/lib/button";
import Popconfirm from "antd/lib/popconfirm";

import { getAllData } from "helpers/api";
import { getGermanWordWithoutArticle } from "helpers";

const Search = Input.Search;

class SearchDrawer extends PureComponent {
  state = {
    allData: [],
    searchTerm: null
  };

  componentDidMount = () => {
    const allData = localStorage.getItem("allData");
    if (!allData) {
      this.fetchAllLevels();
    } else {
      console.log("all levels exist in local storage");
      this.setState({ allData: JSON.parse(allData) });
    }
  };

  fetchAllLevels = async () => {
    this.setState({ allData: [] });
    console.log("fetching all levels");
    const data = [];
    const response = await getAllData();
    JSON.parse(response).forEach(level => {
      level.words.forEach(word => {
        const { image, ...rest } = word;
        data.push({ ...rest, key: word.id, levelID: level.id });
      });
    });
    localStorage.setItem("allData", JSON.stringify(data));
    this.setState({ allData: data });
  };

  render() {
    const { allData, searchTerm } = this.state;
    const { columns, filteredWordIDs, handleLevelChange } = this.props;
    const levelID = {
      title: "levelID",
      key: "levelID",
      render: record => (
        <a onClick={() => handleLevelChange(record.levelID)}>
          {record.levelID}
        </a>
      )
    };

    const filteredColumns = columns.filter(c => c.key !== "image");
    let dataSource = allData;
    if (searchTerm) {
      dataSource = dataSource.filter(word => {
        let lowerCaseParam = searchTerm.toLowerCase();
        const isPattern = lowerCaseParam.includes("=");
        let isSearchByLength = false;
        let length = 0;
        let keys = Object.keys(word);
        if (isPattern) {
          keys = [lowerCaseParam.split("=")[0]];
          isSearchByLength = lowerCaseParam.includes(".length");
          if (isSearchByLength) length = lowerCaseParam.split(".length")[1];
          lowerCaseParam = lowerCaseParam.split("=")[1];
        }
        let includes = false;
        keys
          .filter(key => key !== "levelID" && key !== "key")
          .forEach(key => {
            if (typeof word[key] === "string") {
              if (isSearchByLength) {
                const currentWord =
                  key === "de"
                    ? getGermanWordWithoutArticle(word[key])
                    : word[key];
                if (currentWord.length == length) {
                  includes = true;
                }
              } else {
                if (word[key].toLowerCase().includes(lowerCaseParam)) {
                  includes = true;
                }
              }
            } else if (word[key] == lowerCaseParam) {
              includes = true;
            }
          });
        return includes;
      });
    }

    dataSource = dataSource.filter(word => {
      let includes = true;
      if (filteredWordIDs && filteredWordIDs.indexOf(word.id) !== -1) {
        includes = false;
      }
      return includes;
    });

    return (
      <div>
        <Search
          placeholder="search"
          onChange={e => this.setState({ searchTerm: e.target.value })}
          style={{ width: 200 }}
        />
        <Table
          dataSource={dataSource.slice(0, 20)}
          columns={[levelID, ...filteredColumns]}
          pagination={{ pageSize: 50, position: "both" }}
          scroll={{ x: 900 }}
          loading={allData.length === 0}
        />
        <Popconfirm
          title="DO THIS IF FOUND LEVEL ID IS WRONG"
          okText="GET"
          cancelText="CANCEL"
          onConfirm={this.fetchAllLevels}
        >
          <Button>GET ALL LEVELS</Button>
        </Popconfirm>
      </div>
    );
  }
}

export default SearchDrawer;



// WEBPACK FOOTER //
// ./src/containers/Words/SearchDrawer/index.js